import type { i18n, PostProcessorModule, TOptions } from 'i18next'
import { pseudoLocalizeString } from './pseudoLocalizeString'

export class Pseudo implements PostProcessorModule {
  name: 'pseudo'
  type: 'postProcessor'

  constructor() {
    this.name = 'pseudo'
    this.type = 'postProcessor'
  }

  process(value: string, key: string | string[], options: TOptions, translator: i18n): string {
    if (translator.language !== 'pseudo') {
      return value
    }

    const defaultValue = String(options.defaultValue || value || (Array.isArray(key) ? key[0] : key))
    const splitString = defaultValue.split(/([{]{2}|[}]{2})/g)
    if (splitString.length > 1) {
      let isVariableName = false
      return splitString
        .map((part) => {
          if (part === '{{') {
            isVariableName = true
          } else if (part === '}}') {
            isVariableName = false
          }

          return isVariableName ? String(options[part] ?? '') : pseudoLocalizeString(part, { strategy: 'accented' })
        })
        .join('')
    }
    return pseudoLocalizeString(defaultValue, { strategy: 'accented' })
  }
}
